import {Trans} from '@lingui/macro';
import React, {useState} from 'react';
import CollabGrid from '../component/CollabGrid';
import {Button} from '@material-ui/core';
import {Redirect} from 'react-router-dom';
import SignatureDialog from 'components/Editors/SignatureDialog';
import {i18n2} from 'features/i18n/i18n';
import {validateInstructor} from 'features/capacitation/hookos/hooks';
import {useDispatch, useSelector} from 'react-redux';
import {TABLETCOURSE} from 'features/capacitation/component/actions';
import {makeStyles} from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  btnCancel: {
    fontWeight: 600,
    color: '#8B0000',
    borderColor: '#8B0000',
    backgroundColor: 'rgba(139, 0, 0, 0.1)',
    '&:hover': {
      backgroundColor: 'rgba(139, 0, 0, 0.25)',
      borderColor: '#600000',
    },
  },
  header: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: theme.spacing(2, 4, 1, 4),
  },

  title: {
    margin: 0,
  },
}));

const TabletCoursePage = (props) => {
  const [openExitTabletMode, setOpenExitTabletMode] = useState(false);
  const [redirectFromTablet, setRedirectFromTablet] = useState(false);
  const [signatureResponse, setSignatureResponse] = useState({
    open: false,
    message: '',
  });
  const userState = useSelector((state) => state.authentication.user);
  const dispatch = useDispatch();
  const classes = useStyles();

  const exitTabletMode = () => {
    setOpenExitTabletMode(true);
  };

  if (redirectFromTablet) {
    return <Redirect to="/Management" push />;
  }

  const submit = (values, formikFunctions) => {
    validateInstructor(values.user, values.pass, userState.token).then(
      (response) => {
        if (response.ok) {
          dispatch({
            type: TABLETCOURSE,
            payload: {tablet: false, assistants: false},
          });
          setRedirectFromTablet(true);
          setOpenExitTabletMode(false);
        } else {
          response.text().then((respMessage) => {
            setSignatureResponse({open: true, message: respMessage});
            formikFunctions.resetForm();
          });
        }
      },
    );
  };

  return (
    <>
      {setOpenExitTabletMode && (
        <SignatureDialog
          openDialog={openExitTabletMode}
          onCloseDialog={() => setOpenExitTabletMode(false)}
          dialogTitle={i18n2._('Confirmar operación')}
          user={userState.name}
          submit={(values, formikFunctions) => submit(values, formikFunctions)}
          snackbarState={signatureResponse}
          onCloseSnackbar={() => {
            setSignatureResponse({open: false, message: ''});
          }}
        />
      )}
      <div className={classes.header}>
        <h2 className={classes.title}>
          <Trans>Asistentes</Trans>
        </h2>

        <Button
          variant="outlined"
          onClick={exitTabletMode}
          className={classes.btnCancel}>
          <Trans>Salir de modo tablet</Trans>
        </Button>
      </div>

      <CollabGrid
        iD_Instance={props.location.state.data.iD_Instance}
        iD_Course={props.location.state.data.iD_Course}
        employee_Nr={props.location.state.data.employee_Nr}
        status={props.location.state.data.status}
      />
    </>
  );
};

export default TabletCoursePage;
